export default "__VITE_ASSET__Dum7NVNM__"